<template>
  <toggle
    :disabled="disabled"
    :label="label"
    :name="name"
    :value="value"
    @update:data="(checked) => $emit('update:data', checked)"
  >
  </toggle>
</template>

<script>
import Toggle from '@kanrisha/components/Elements/Form/Toggle';

export default {
  components: {
    Toggle,
  },
  props: {
    disabled: { type: Boolean, default: () => false },
    errors: { type: Array, default: null },
    name: { type: String, default: () => '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    label: { type: String, default: () => '' },
    value: { type: String, default: () => null },
  },
  emits: ['update:data'],
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.form-floating > .form-control:not(:placeholder-shown) {
  padding: 0.4375rem 0 0 0;
}
</style>
